import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import KnowledgeBaseArticleView from "../../Sections/Knowledgebase/ArticleViewPage";

const KnowledgeBaseArticleViewComponent = () => {
  return <Dashboard sectionName={<KnowledgeBaseArticleView />} />;
};

export default KnowledgeBaseArticleViewComponent;